import { Injectable, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { FormsBase } from 'src/app/common-components/forms-base/forms-base';
import { ScheduleDetailForm, ScheduleDetailFormValue } from '../models/schedule-detail-form';
import { ScheduleDetailSaveModel } from '../models/schedule-detail-save.model';
import { ScheduleDetailView } from '../models/schedule-detail-view.model';

@Injectable()
export class ScheduleDetailFormService extends FormsBase implements OnDestroy {
   private destroyed$ = new Subject<void>();

   pattern = '^\\s*(?!\\s)[a-zA-Z0-9./\\\\\\-_*()$%^!@#&?, ]+(?<!\\s)\\s*$';

   constructor(fb: UntypedFormBuilder, private store: Store, private action: Actions) {
      super();

      const form: ScheduleDetailForm = {
         closedExceptions: fb.control([]),
         description: fb.control(null, Validators.pattern(this.pattern)),
         name: fb.control(null, [Validators.pattern(this.pattern), Validators.maxLength(255)]),
         scheduleHours: fb.control([]),
      };

      this.form = fb.group(form);
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   updateSchedule(schedule: ScheduleDetailView): void {
      if (!schedule) {
         return;
      }

      const formValue = {
         closedExceptions: schedule.closedExceptionsConnection?.items ?? null,
         description: schedule.description ?? null,
         name: schedule.name,
         scheduleHours: schedule.scheduleDetailsConnection?.items ?? null,
         scheduleId: schedule.scheduleId,
      };

      this.form.patchValue(formValue);
      this.markAsUntouchedAndPristine();
   }

   getValue(scheduleId: number | null): ScheduleDetailSaveModel {
      const value = this.form.value as ScheduleDetailFormValue;
      return {
         closedExceptions: value.closedExceptions ?? null,
         description: value.description ?? null,
         name: value.name,
         scheduleHours: value.scheduleHours ?? null,
         scheduleId: scheduleId,
      };
   }
}
